import React from "react";
import OrderPills from "../../../../../atoms/Pills/OrderPills";
import { ParseDate, ParseDateTime } from "../../../../../../../helpers/Parsers";

import styles from  "./TableItemMobile.module.scss";
import i18n from "i18n";
export const RelocationOrderItemMobile = ({ relocationOrder, handleClick }) => {
  const prueba = e => {
    handleClick(e);
  };
  return (
    <div
      className={styles["relocation-order-table-item-mobile-container"]}
      data-automation-id="relocation-order-table-item"
      data-relocation-order-id={relocationOrder.id}
      onClick={prueba}
    >
      <div className={styles["relocation-order-table-item-mobile-code"]}>
        Nro {relocationOrder.code}
      </div>

      <div className={styles["relocation-order-table-item-mobile-date"]}>
        {i18n.t("date")}: {ParseDate(relocationOrder.created_at)}
      </div>

      <div className={styles["relocation-order-table-item-mobile-bottom"]}>
        <div className={styles["relocation-order-table-item-mobile-owner"]}>
        {i18n.t("owner")}:{" "}
          {relocationOrder.owner
            ? `${relocationOrder.owner.first_name} ${relocationOrder.owner.last_name}`
            : "-"}
        </div>
        <div className={styles["relocation-order-table-item-mobile-state-inner"]}>
          <OrderPills state={relocationOrder.status}></OrderPills>
        </div>
      </div>
    </div>
  );
};

export default RelocationOrderItemMobile;
